import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import './index.scss';

const ModalName = 'ModalLogin';

const Login = ({ name, toggleModal }) => {
    const localize = useSelector((state) => state.localize.event, shallowEqual);
	const closeModal = () => toggleModal(ModalName);
    const onClick = (e) => {
        e.preventDefault();
        const id = e.target.name;
        window.location.href = process.env.REACT_APP_API_ENDPOINT + 'oauth/login/' + id;
    }
	return (
		<Modal
			open={name[ModalName]}
			classNames={{
				modal: `modal modal-login`,
				overlay: 'overlay',
				closeButton: 'close-button',
				closeIcon: 'close-icon',
				modalAnimationIn: 'slideInUp',
				modalAnimationOut: 'slideOutDown',
			}}
			animationDuration={250}
			center
			focusTrapped={false}
			onClose={closeModal}
			blockScroll={false}
		>
			<div className="modal-title">
				<h3>{localize?.txt_login_title}</h3>
			</div>
			<div className="modal-content">
				<p>{localize?.txt_login_freefire}</p>
				<div className="group">
					<button onClick={onClick} name="google" className="btn btn-login google">
						<img alt="" src={process.env.REACT_APP_CDN_URL + 'ico_google.png'} />
						Sign in with Google
					</button>
					<button onClick={onClick} name="fb" className="btn btn-login fb">
						<img alt="" src={process.env.REACT_APP_CDN_URL + 'ico_facebook_2.png'} />
						Sign in with Facebook
					</button>
				</div>
				<div className="group">
					<button onClick={onClick} name="vk" className="btn btn-login vk">
						<img alt="" src={process.env.REACT_APP_CDN_URL + 'ico_vk.png'} />
						Sign in with VK
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default Login;
